<template>
  <div class="rich-text" v-html="this.imprints"></div>
</template>

<script>
export default {
  name: "Imprints",

  computed: {
    config() {
      return this.$store.getters["config/config"] || {};
    },

    imprints() {
      return (this.config && this.config.imprints) || "";
    },
  },
};
</script>
